<script>
/* eslint-disable no-console */
import NewForm from './New'
export default {
  mixins: [NewForm],
  data() {
    return {
      valid: false,
      form: {
        loadingPorts: [],
        exceptLoadingPorts: [],
        dischargePorts: [],
        exceptDischargePorts: [],
        standard: 'ETA',
      },
    }
  },
  methods: {
    load() {
      var id = this.$route.query.id
      this.$http.get(`/free-days/${id}`).then((res) => {
        this.form = res.data
        this.transferData(this.form.freeDaysPortVos)
      })
    },
    save() {
      this.dealData()
      this.$http
        .put(`/free-days/${this.form.id}`, this.form)
        .then(() => {
          this.$router.go(-1)
          this.$message('', 'FreeDays修正しました。')
        })
        .catch(() => {
          this.$message('', 'FreeDays修正できません。')
        })
    },
    transferData(list) {
      this.form.loadingPorts = list
        .filter((l) => 'LOADING_PORT' === l.portType)
        .map((l) => l.portCode)

      this.form.exceptLoadingPorts = list
        .filter((l) => 'EXCEPT_LOADING_PORT' === l.portType)
        .map((l) => l.portCode)

      this.form.dischargePorts = list
        .filter((l) => 'DISCHARGE_PORT' === l.portType)
        .map((l) => l.portCode)

      this.form.exceptDischargePorts = list
        .filter((l) => 'EXCEPT_DISCHARGE_PORT' === l.portType)
        .map((l) => l.portCode)
    },
  },
  mounted() {
    this.load()
  },
}
</script>
